import { FC } from 'react';

type ErrorInitProps = {
  items: string[];
};

export const ErrorInit: FC<ErrorInitProps> = ({ items }) => {
  return (
    <>
      <div>[collections] Error pull/parse/decrypt collection.</div>
      <div>
        {items.map((item, index) => (
          <div key={index}>{item}</div>
        ))}
      </div>
    </>
  );
};
